import { ACTION_TYPE_PREFIX } from 'ContentEditorUI/redux/actions/inpageReduxActionTypes';
export const DELETE_MODULE_FROM_PARENT = `${ACTION_TYPE_PREFIX}DELETE_MODULE_FROM_PARENT`;
export const DELETE_SECTION_FROM_PARENT = `${ACTION_TYPE_PREFIX}DELETE_SECTION_FROM_PARENT`;
export const SELECT_IS_SINGLE_COLUMN_FULL_WIDTH_FROM_PARENT = `${ACTION_TYPE_PREFIX}SELECT_IS_SINGLE_COLUMN_FULL_WIDTH_FROM_PARENT`;
export const CLOSE_INPAGE_MODAL = `${ACTION_TYPE_PREFIX}CLOSE_INPAGE_MODAL`;
export const OPEN_INPAGE_MODAL = `${ACTION_TYPE_PREFIX}OPEN_INPAGE_MODAL`;